/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PrincipalRolesControllerFindRoleHoldersQueryResponse, PrincipalRolesControllerFindRoleHoldersQueryParams, PrincipalRolesControllerFindRoleHolders401, PrincipalRolesControllerFindRoleHolders403 } from "../../models/principalRolesController/PrincipalRolesControllerFindRoleHolders";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { principalRolesControllerFindRoleHolders } from "../../clients/principal-rolesService/principalRolesControllerFindRoleHolders";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const principalRolesControllerFindRoleHoldersQueryKey = (params: PrincipalRolesControllerFindRoleHoldersQueryParams) => [{
  url: '/api/v1/principal-roles/role-holders'
}, ...(params ? [params] : [])] as const;
export type PrincipalRolesControllerFindRoleHoldersQueryKey = ReturnType<typeof principalRolesControllerFindRoleHoldersQueryKey>;
export function principalRolesControllerFindRoleHoldersQueryOptions(params: PrincipalRolesControllerFindRoleHoldersQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = principalRolesControllerFindRoleHoldersQueryKey(params);
  return queryOptions<PrincipalRolesControllerFindRoleHoldersQueryResponse, ResponseErrorConfig<PrincipalRolesControllerFindRoleHolders401 | PrincipalRolesControllerFindRoleHolders403>, PrincipalRolesControllerFindRoleHoldersQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return principalRolesControllerFindRoleHolders(params, config);
    }
  });
}

/**
 * @summary List who holds each of a set of roles at a scope
 * {@link /api/v1/principal-roles/role-holders}
 */
export function usePrincipalRolesControllerFindRoleHolders<TData = PrincipalRolesControllerFindRoleHoldersQueryResponse, TQueryData = PrincipalRolesControllerFindRoleHoldersQueryResponse, TQueryKey extends QueryKey = PrincipalRolesControllerFindRoleHoldersQueryKey>(params: PrincipalRolesControllerFindRoleHoldersQueryParams, options: {
  query?: Partial<QueryObserverOptions<PrincipalRolesControllerFindRoleHoldersQueryResponse, ResponseErrorConfig<PrincipalRolesControllerFindRoleHolders401 | PrincipalRolesControllerFindRoleHolders403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? principalRolesControllerFindRoleHoldersQueryKey(params);
  const query = useQuery({
    ...principalRolesControllerFindRoleHoldersQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PrincipalRolesControllerFindRoleHolders401 | PrincipalRolesControllerFindRoleHolders403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}